import Masonry from "masonry-layout"
import { q, qq } from "../../helper/q"

export const masonryInit = () => {
  const msnry = new Masonry(".articlesGroup", {
    itemSelector: ".articleCardBig",
    gutter: 30
  })
  msnry.on("layoutComplete", (event, items) => {
    setTimeout(() => {
      const cards = qq(".articleCardBig")
      cards.map(card => {
        card.classList.add("articleCardHover")
      })
    }, 500)
  })
  return msnry
}
